import { Flex, Icon, Tooltip } from '@chakra-ui/react';
import { KText } from '@/ui-library/components/text';
import { SCHEDULE_AI_COPY } from '../../constants';
import { CalendarClose, FaceSad } from '@kula-ai/icons-core';

type Props = {
  iconSize?: number;
  onClick?: (_e: React.MouseEvent) => void;
};

export const CalendarNotConnectedTooltip = ({
  iconSize = 14,
  onClick,
}: Props) => (
  <Tooltip
    placement="top"
    bg="#FFF"
    borderRadius="6px"
    boxShadow="0px 18px 18px rgba(215, 218, 235, 0.09), 0px 4px 10px rgba(215, 218, 235, 0.1)"
    shouldWrapChildren
    label={
      <Flex align="center" gap="6px" p="8px">
        <Icon
          as={FaceSad as unknown as React.ElementType}
          w="18px"
          h="18px"
          color="secondary-700"
        />
        <KText fontSize="xs" color="secondary-900">
          {SCHEDULE_AI_COPY.calendarNotConnectedTooltip}
        </KText>
      </Flex>
    }
  >
    <Icon
      as={CalendarClose as unknown as React.ElementType}
      w={`${iconSize}px`}
      h={`${iconSize}px`}
      color="secondary-700"
      onClick={onClick}
    />
  </Tooltip>
);
